import { useFormContext } from 'react-hook-form';
import { Input } from '@/components/common';
import type { MotorQuoteFormData } from '../../schema';

function todayISO(): string {
  const d = new Date();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
}

export function RegistrationDateStep() {
  const {
    register,
    formState: { errors },
  } = useFormContext<MotorQuoteFormData>();

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Registration Date</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
        When was (or will be) the vehicle registered with the RTO?
      </p>
      <div className="sm:max-w-xs">
        <Input
          label="Registration Date"
          type="date"
          max={todayISO()}
          error={errors.registration_date?.message}
          required
          {...register('registration_date')}
        />
      </div>
    </div>
  );
}
